
import UEI from '../use/useEditInfo'
import { quickBarMethods } from "./quickBar";
// 键盘按键的上下左右步数
const STEP_NUMBER = 1

export const keyboardMethods = {
  // 监听鼠标按下事件
  keyDown:(event: KeyboardEvent): void => {
    if(!(UEI.clickElement && UEI.state.clickLayout)) return
    const key = event.key
    if(key === 'Delete') {
      keyboardMethods.deleteLayout()
    } else if(['ArrowRight','ArrowLeft','ArrowDown', 'ArrowUp'].includes(key)) {
      keyboardMethods.moveLayout(key)
    }
  },
  // 监听鼠标抬起事件
  keyUp: (event: KeyboardEvent): void => {
    // ......
  },
  // 删除布局
  deleteLayout() {
    // if(confirm('确定要删除这个组件吗')) 
    quickBarMethods.deleteLayout()
  },
  // 布局上下左右移动
  moveLayout(key: string) {
    if(!(UEI.clickElement && UEI.state.clickLayout)) return
    const left = UEI.state.clickLayout?.styleConfig?.left
    const top = UEI.state.clickLayout?.styleConfig?.top
    switch (key) {
      case 'ArrowRight':
        if(typeof left === 'number' && (left === 0 ||!!typeof left)) {
          ;(UEI.state.clickLayout.styleConfig as any).left = left + STEP_NUMBER
        }
        break;
      case 'ArrowLeft':
        if(typeof left === 'number' && (left === 0 ||!!typeof left)) {
          ;(UEI.state.clickLayout.styleConfig as any).left = left - STEP_NUMBER
        }
        break;
      case 'ArrowDown':
        if(typeof top === 'number' && (top === 0 ||!!typeof top)) {
          ;(UEI.state.clickLayout.styleConfig as any).top = top + STEP_NUMBER
        }
        break;
      case 'ArrowUp':
        if(typeof top === 'number' && (top === 0 ||!!typeof top)) {
          ;(UEI.state.clickLayout.styleConfig as any).top = top - STEP_NUMBER
        }
        break;
    }
  }
}